import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingDomainsActions from '../actions/hosting-domains.action';
import {LoadZones} from '../actions/hosting-domains.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap, switchMap} from 'rxjs/operators';
import {Utils} from "../../shared/utils/utils";
import {LoadDomains, UPDATE_WEBSITE_SUB_DATA, UpdateWebsiteSubData} from '../actions';
import {HostingService} from "../../websites/website/hosting/hosting.service";

@Injectable()
export class HostingDomainsEffects {

  updateWebsiteSubData$ = createEffect(() => this._actions$.pipe(
    ofType(UPDATE_WEBSITE_SUB_DATA),
    filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
    switchMap((action: UpdateWebsiteSubData) => [
      new hostingDomainsActions.LoadDomains({
        websiteId: action.payload.id,
        childWebsiteId: action.payload.multisiteType === 'subfolder' && action.payload.children ? action.payload.children[0] : null
      }),
      new hostingDomainsActions.LoadZones()
    ])
  ));
  loadDomains$ = createEffect(() => this._actions$.pipe(
    ofType(hostingDomainsActions.LOAD_DOMAINS),
    mergeMap((action: LoadDomains) => {
      return this._hostingService.getDomains(action.payload.childWebsiteId ? action.payload.childWebsiteId : action.payload.websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingDomainsActions.LoadDomainsSuccess({
                websiteId: action.payload.childWebsiteId ? action.payload.childWebsiteId : action.payload.websiteId,
                domainEntities: Utils.arrayToEntities(response.data, 'id')
              });
            }
            return new hostingDomainsActions.LoadDomainsFail(response.message);
          })
        )
    })
  ));
  loadZones$ = createEffect(() => this._actions$.pipe(
    ofType(hostingDomainsActions.LOAD_ZONES),
    mergeMap((action: LoadZones) => {
      return this._hostingService.getZones()
            .pipe(
              filter((response: DbResponse) => !!response),
              map((response: DbResponse) => {
                if (response.success) {
                  return new hostingDomainsActions.LoadZonesSuccess({
                    zoneEntities: response.data
                  });
                }
                return new hostingDomainsActions.LoadZonesFail(response.message);
              })
            );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
